import axios from "axios";

// Points at the NearbyDeals backend that the mobile app also uses (production).
// No fallback to REACT_APP_BACKEND_URL on purpose: falling back silently to a
// different backend previously caused web/app data to mismatch.
const BACKEND_URL = process.env.REACT_APP_NEARBYDEALS_API;
if (!BACKEND_URL) {
  // Loud, once. Helps diagnose deploys that forgot to bake the env var.
  console.error(
    "[NearbyDeals] REACT_APP_NEARBYDEALS_API is not set — API calls will fail. " +
      "Set it in your build environment and redeploy."
  );
}
export const API = `${BACKEND_URL || ""}/api`;
export const API_CONFIGURED = Boolean(BACKEND_URL);

const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
